import React from 'react';

export const BlobSVG = React.memo(() => {
    return (
        <svg
            className="blob-svg"
            width="515"
            height="530"
            viewBox="0 0 515 530"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M335.445 527.404C308.219 533.74 272.293 529.458 261.754 503.573C251.241 477.742 274.395 445.027 258.963 421.803C247.368 404.355 221.959 404.667 201.282 408.064C144.161 417.452 86.72 435.597 29.5375 426.586C20.6388 425.182 11.1008 422.671 5.62736 415.518C1.63212 410.304 0.510773 403.465 0.153866 396.906C-2.50962 347.926 29.8411 304.383 63.465 268.659C193.626 131.12 364.458 38.9227 550.884 5.59934C572.868 1.72999 595.226 -1.3085 617.471 0.571586C634.563 2.0176 654.552 9.49257 657.69 26.3521C659.437 35.7072 655.239 45.4938 657.381 54.769C659.778 65.1814 669.883 72.4034 680.329 74.6696C690.776 76.9358 701.637 75.2022 712.177 73.4686L804.472 58.2761C832.29 53.6957 865.269 50.7692 884.297 71.5646C901.791 90.6823 898.413 120.67 890.796 145.434C870.119 212.619 827.032 271.338 775.627 319.304C678.622 409.846 551.049 477.231 335.445 527.404Z"
                fill="#3659E3"
                fillOpacity="0.08"
            />
        </svg>
    );
});
